'use strict';

var cov_1dj86pxxuw = function () {
  var path = '/Users/jvvbsocianova/Projects/socianova/marty/src/app/dashboard/chart/chart.component.js',
      hash = '98c8b995dfce54a82aa0da11323d1898275a8cbb',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/jvvbsocianova/Projects/socianova/marty/src/app/dashboard/chart/chart.component.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 25
        }
      },
      '1': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 25,
          column: 6
        }
      },
      '2': {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 65
        }
      },
      '3': {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 21
        }
      },
      '4': {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 21
        }
      },
      '5': {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 24
        }
      },
      '6': {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 30
        }
      },
      '7': {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 30
        }
      },
      '8': {
        start: {
          line: 41,
          column: 20
        },
        end: {
          line: 41,
          column: 33
        }
      },
      '9': {
        start: {
          line: 42,
          column: 20
        },
        end: {
          line: 42,
          column: 31
        }
      },
      '10': {
        start: {
          line: 43,
          column: 18
        },
        end: {
          line: 43,
          column: 25
        }
      },
      '11': {
        start: {
          line: 44,
          column: 23
        },
        end: {
          line: 44,
          column: 31
        }
      },
      '12': {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 49,
          column: 5
        }
      },
      '13': {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 42
        }
      },
      '14': {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 55,
          column: 5
        }
      },
      '15': {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 37
        }
      },
      '16': {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 37
        }
      },
      '17': {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 28
        }
      },
      '18': {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 61,
          column: 7
        }
      },
      '19': {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 59,
          column: 41
        }
      },
      '20': {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 60,
          column: 41
        }
      },
      '21': {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 48
        }
      },
      '22': {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 48
        }
      },
      '23': {
        start: {
          line: 68,
          column: 23
        },
        end: {
          line: 68,
          column: 71
        }
      },
      '24': {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 82,
          column: 7
        }
      },
      '25': {
        start: {
          line: 70,
          column: 25
        },
        end: {
          line: 70,
          column: 27
        }
      },
      '26': {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 71,
          column: 32
        }
      },
      '27': {
        start: {
          line: 72,
          column: 20
        },
        end: {
          line: 72,
          column: 56
        }
      },
      '28': {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 79,
          column: 7
        }
      },
      '29': {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 76,
          column: 52
        }
      },
      '30': {
        start: {
          line: 78,
          column: 8
        },
        end: {
          line: 78,
          column: 50
        }
      },
      '31': {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 81,
          column: 34
        }
      },
      '32': {
        start: {
          line: 87,
          column: 0
        },
        end: {
          line: 109,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 4,
            column: 3
          }
        }
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        loc: {
          start: {
            line: 6,
            column: 12
          },
          end: {
            line: 36,
            column: 3
          }
        }
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        loc: {
          start: {
            line: 38,
            column: 18
          },
          end: {
            line: 83,
            column: 3
          }
        }
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 58,
            column: 30
          },
          end: {
            line: 58,
            column: 31
          }
        },
        loc: {
          start: {
            line: 58,
            column: 39
          },
          end: {
            line: 61,
            column: 5
          }
        }
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 69,
            column: 36
          },
          end: {
            line: 69,
            column: 37
          }
        },
        loc: {
          start: {
            line: 69,
            column: 43
          },
          end: {
            line: 82,
            column: 5
          }
        }
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        }, {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        }]
      },
      '1': {
        loc: {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }, {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }]
      },
      '2': {
        loc: {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 79,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 79,
            column: 7
          }
        }, {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 79,
            column: 7
          }
        }]
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChartComponent = function () {
  function ChartComponent(lodash) {
    _classCallCheck(this, ChartComponent);

    ++cov_1dj86pxxuw.f[0];
    ++cov_1dj86pxxuw.s[0];

    this.lodash = lodash;
  }

  _createClass(ChartComponent, [{
    key: '$onInit',
    value: function $onInit() {
      ++cov_1dj86pxxuw.f[1];
      ++cov_1dj86pxxuw.s[1];

      // Graphique Options.
      this.options = {
        scaleStartValue: 0,
        legend: {
          display: true,
          position: "top",
          labels: {
            fontSize: 14
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              beginAtZero: true
            }
          }]
        }
      };
      // Type du graphique
      ++cov_1dj86pxxuw.s[2];
      this.type = this.lodash.get(this.indicator, 'chart', 'line');
      // series
      ++cov_1dj86pxxuw.s[3];
      this.series = [];
      // labels
      ++cov_1dj86pxxuw.s[4];
      this.labels = [];
      // chartData
      ++cov_1dj86pxxuw.s[5];
      this.chartData = [];
      // log
      ++cov_1dj86pxxuw.s[6];
      this.parseData(this.data);
    }
  }, {
    key: 'parseData',
    value: function parseData(data) {
      var _this = this;

      ++cov_1dj86pxxuw.f[2];
      ++cov_1dj86pxxuw.s[7];

      // Copy data pour manipulation.
      data = angular.copy(data);
      var labelName = (++cov_1dj86pxxuw.s[8], 'date_valeur');
      var serieName = (++cov_1dj86pxxuw.s[9], 'structure');
      var refName = (++cov_1dj86pxxuw.s[10], 'serie');
      var valeurName = (++cov_1dj86pxxuw.s[11], 'valeur');

      // Si c'est horizontal bar
      ++cov_1dj86pxxuw.s[12];
      if (this.type === 'horizontal-bar') {
        ++cov_1dj86pxxuw.b[0][0];
        ++cov_1dj86pxxuw.s[13];

        this.options.legend.display = false;
      } else {
        ++cov_1dj86pxxuw.b[0][1];
      }

      ++cov_1dj86pxxuw.s[14];
      if (this.type !== 'line') {
        ++cov_1dj86pxxuw.b[1][0];
        ++cov_1dj86pxxuw.s[15];

        labelName = 'dimension_valeur';
        ++cov_1dj86pxxuw.s[16];
        serieName = 'dimension_valeur';
        ++cov_1dj86pxxuw.s[17];
        refName = 'reference';
      } else {
        ++cov_1dj86pxxuw.b[1][1];
      }

      // Data foreach.
      ++cov_1dj86pxxuw.s[18];
      this.lodash.forEach(data, function (value) {
        ++cov_1dj86pxxuw.f[3];
        ++cov_1dj86pxxuw.s[19];

        _this.labels.push(value[labelName]);
        ++cov_1dj86pxxuw.s[20];
        _this.series.push(value[serieName]);
      });

      // uniq.
      ++cov_1dj86pxxuw.s[21];
      this.labels = this.lodash.uniq(this.labels);
      ++cov_1dj86pxxuw.s[22];
      this.series = this.lodash.uniq(this.series);

      // lier les données avec les series.
      var references = (++cov_1dj86pxxuw.s[23], this.lodash.uniq(this.lodash.map(data, refName)));
      ++cov_1dj86pxxuw.s[24];
      this.lodash.forEach(references, function (ref) {
        ++cov_1dj86pxxuw.f[4];

        var comparator = (++cov_1dj86pxxuw.s[25], {});
        ++cov_1dj86pxxuw.s[26];
        comparator[refName] = ref;
        var facts = (++cov_1dj86pxxuw.s[27], _this.lodash.filter(data, comparator));
        // extraction de la valeur.
        var values = void 0;
        ++cov_1dj86pxxuw.s[28];
        if (_this.type !== 'line') {
          ++cov_1dj86pxxuw.b[2][0];
          ++cov_1dj86pxxuw.s[29];

          values = _this.lodash.sumBy(facts, 'valeur');
        } else {
          ++cov_1dj86pxxuw.b[2][1];
          ++cov_1dj86pxxuw.s[30];

          values = _this.lodash.map(facts, 'valeur');
        }

        ++cov_1dj86pxxuw.s[31];
        _this.chartData.push(values);
      });
    }
  }]);

  return ChartComponent;
}();

++cov_1dj86pxxuw.s[32];


angular.module('app').component('chart', {
  bindings: {
    indicator: '=',
    data: '='
  },
  template: '\n    <div ng-if="$ctrl.type === \'line\'">\n    <canvas id="line" class="chart chart-line" chart-data="$ctrl.chartData" chart-series="$ctrl.series" chart-options="$ctrl.options" chart-labels="$ctrl.labels"></canvas>\n    </div>\n    <div ng-if="$ctrl.type === \'pie\'">\n    <canvas id="pie" class="chart chart-pie" chart-data="$ctrl.chartData" chart-series="$ctrl.series" chart-options="$ctrl.options" chart-labels="$ctrl.labels"></canvas>\n    </div>\n    <div ng-if="$ctrl.type === \'bar\'">\n    <canvas id="bar" class="chart chart-bar" chart-data="$ctrl.chartData" chart-series="$ctrl.series" chart-options="$ctrl.options" chart-labels="$ctrl.labels"></canvas>\n    </div>\n    <div ng-if="$ctrl.type === \'horizontal-bar\'">\n    <canvas class="chart-horizontal-bar" chart-data="$ctrl.chartData" chart-series="$ctrl.series" chart-options="$ctrl.options" chart-labels="$ctrl.labels"></canvas>\n    </div>\n    ',
  controller: ChartComponent
});